import React, {createContext, useContext, useState, useMemo, useEffect} from "react";
import {useScreensizeContext} from "./ScreensizeProvider";

export type MobileMenuContextType = {
    isMobileMenuOpen: boolean;
    setIsMobileMenuOpen: (isMobileMenuOpen: boolean) => void;
};

const MobileMenuContext = createContext<MobileMenuContextType>({
    isMobileMenuOpen: false,
    setIsMobileMenuOpen: () => {},
});

export function useMobileMenu() {
    return useContext(MobileMenuContext);
}

type MobileMenuProviderProps = {
    children: React.ReactNode;
};

export const MobileMenuProvider = ({children}: MobileMenuProviderProps) => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState<boolean>(false);
    const {isSmallDeviceDimension} = useScreensizeContext();

    useEffect(() => {
        if (!isSmallDeviceDimension) setIsMobileMenuOpen(false);
    }, [isSmallDeviceDimension]);

    const value = useMemo(() => ({isMobileMenuOpen, setIsMobileMenuOpen}), [isMobileMenuOpen]);

    return <MobileMenuContext.Provider value={value}>{children}</MobileMenuContext.Provider>;
};
